import _ from "lodash";

const initState = {
  orders: [],
  metadata: [],
  searched: [],
  order: {},
  orderLeg: {},
  toast: null,
  isProcessing: false,
};

const toastMessageByAction = {
  'OTR_ASSIGN_DRIVER': 'Driver assigned.',
  'OTR_UNASSIGN_DRIVER': 'Driver unassigned.',
  'OTR_CHANGE_DRIVER': 'Driver updated.',
  'OTR_CHANGE_DRIVER_RATE': 'Driver Rate updated',
  'SAVE_LEG_CHARGE': 'Charges saved successfully.',
  'UPDATE_LEG_CHARGE': 'Charges updated successfully.',
  'DELETE_LEG_CHARGE': 'Charges deleted.',
  'OTR_UPDATE_ORDER_LOCATION': 'Order location updated.',
  'OTR_UPDATE_ORDER_EQUIPMENT': 'Order equipment updated.',
  'OTR_UPDATE_ORDER_SUMMARY': 'Order updated',
  'OTR_UPDATE_ORDER_RATE': 'Order rate updated.',
  'OTR_SAVE_EXPENSE': 'Expense saved successfully.',
  'OTR_UPDATE_EXPENSE': 'Expense updated successfully.',
  'OTR_DELETE_EXPENSE': 'Expense deleted.',
};

export const otrOrderReducer = (state = initState, action) => {
  const actionType = action.type;
  switch (actionType) {
  case 'OTR_RESET_ORDER_STATE':
    return {
      ...initState
    };
  case 'OTR_RESET_TOAST_STATE':
    return {
      ...state,
      toast: null, 
      isProcessing: false,
    };    
  case 'OTR_PROCESSING_ORDER':
    return {
      ...state,
      isProcessing: true,
      toast: { type: 'LOADING', message: 'Please wait ...'},
    };
  case 'OTR_FETCH_ORDERS':
    return {
      ...state,
      orders: action.payload && action.payload.content,
      metadata: action.payload,
      isProcessing: false,
      toast: { type: 'SUCCESS'},
    };
  case 'OTR_SEARCH_ORDER_SUCCESS':
    return {
      ...state,
      searched: action.payload,
      isProcessing: false,
      toast: { type: 'SUCCESS' },
    };
  case 'OTR_ADD_ORDER':
    return {
      ...state,
      orders: [...state.orders, action.payload],
      order: action.payload,
      isProcessing: false,
      toast: { type: 'SUCCESS', message: 'Order saved successfully.'},
    };    
  case 'OTR_UPDATE_ORDER':
    return {
      ...state,
      orders: state.orders.map(odr => odr.id === action.payload.id ? {...action.payload } : { ...odr }),
      searched: state.searched.map(odr => odr.id === action.payload.id ? {...action.payload } : { ...odr }),
      order: action.payload,
      isProcessing: false,
      toast: { type: 'SUCCESS', message: 'Order updated successfully.' },
    };
  case 'OTR_DELETE_ORDER':
    // eslint-disable-next-line no-case-declarations
    const id = Number(action.payload.substring(15));    
    return {
      ...state,
      orders: state.orders.filter(order => {return order.id !== id;}),
      searched: state.searched.filter(order => {return order.id !== id;}),
      order: null,
      isProcessing: false,
      toast: { type: 'SUCCESS', message: 'Order Deleted Successfully.'},
    };
  case 'OTR_DELETE_ORDER_LEG':
    return {
      ...state,
      orders: [...state.orders.filter(order => order.id !== Number(action.payload)),
        Object.assign({}, action.payload)],
      order: null,
      isProcessing: false,
      toast: { type: 'SUCCESS' },
    };
  case 'OTR_FETCH_CURRENT_ORDER':
  case 'OTR_SET_CURRENT_ORDER':
    return {
      ...state,
      orders: state.orders.map(order => {
        return order.id === (action.payload && action.payload.id) ? _.cloneDeep(action.payload) : { ...order };
      }),
      // update search orders only if we are on search table.
      searched: state.searched.map(order => {
        return order.id === (action.payload && action.payload.id) ? _.cloneDeep(action.payload) : { ...order };
      }),
      order: action.payload,
      isProcessing: false,
      toast: {type: 'SUCCESS'}
    };
  case 'OTR_STATUS_CHANGE':
    return {
      ...state,
      orders: state.orders.map((order) => order.id === action.payload.id ? { ...action.payload } : { ...order }),
      searched: state.searched.map((order) => order.id === action.payload.id ? { ...action.payload } : { ...order }),
      order: action.payload,
      isProcessing: false,
      toast: {type: 'SUCCESS'}
    };
  case 'OTR_STATE_CHANGE':
    const resp = action.payload.content;
    let o = _.find(resp, {id: state.order.id});
    o = o && o.lastModified >= state.order.lastModified ? o : state.order;
    return {
      ...state,
      orders: state.orders.map((order) => {
        var l = _.find(resp, {id: order.id});
        if(l && l.lastModified > order.lastModified) {
          return l;
        }
        return order;
      }),
      order: o
    };
  case 'OTR_FETCH_LEG':
    return {
      ...state,
      activeLeg: action.payload,
      toast: { type: 'SUCCESS' },
    };
  case 'OTR_UPDATE_ORDER_LOCATION':
  case 'OTR_UPDATE_ORDER_EQUIPMENT':
  case 'OTR_UPDATE_ORDER_SUMMARY':
  case 'OTR_UPDATE_ORDER_RATE':    
    return {
      ...state,
      orders: state.orders.map(order => order.id === action.payload.id ? { ...action.payload } : { ...order }),
      searched: state.searched.map(order => order.id === action.payload.id ? { ...action.payload } : { ...order }),
      order: action.payload,
      isProcessing: false,
      toast: { type: 'SUCCESS', message: toastMessageByAction[actionType]},
    };
  
  case 'OTR_SAVE_EXPENSE':
    // eslint-disable-next-line no-case-declarations
    const saved = {...state.order, expenses: [...state.order.expenses, {...action.payload}] };
    return {
      ...state,
      orders: state.orders.map(order => order.id === saved.id ? { ...saved } : { ...order }),
      // update search orders only if we are on search table.
      searched: state.searched.map(order => order.id === saved.id ? { ...saved } : { ...order }),
      order: saved,
      isProcessing: false,
      toast: {type: 'SUCCESS', message: toastMessageByAction[actionType]}
    };    
  case 'OTR_UPDATE_EXPENSE':
    // eslint-disable-next-line no-case-declarations
    const updated = {...state.order, expenses: state.order.expenses.map(exp => exp.id === action.payload.id ? {...action.payload } : {...exp})};
    return {
      ...state,
      orders: state.orders.map(order => order.id === updated.id ? { ...updated } : { ...order }),
      // update search orders only if we are on search table.
      searched: state.searched.map(order => order.id === updated.id ? { ...updated } : { ...order }),
      order: updated,
      isProcessing: false,
      toast: {type: 'SUCCESS', message: toastMessageByAction[actionType]}
    };
  case 'OTR_DELETE_EXPENSE':
    // eslint-disable-next-line no-case-declarations     
    const deleted = {...state.order, expenses: [...state.order.expenses.filter(exp => exp.id !== action.payload)]};
    return {
      ...state,
      orders: state.orders.map(order => order.id === deleted.id ? { ...deleted } : { ...order }),      
      // update search orders only if we are on search table.
      searched: state.searched.map(order => order.id === deleted.id ? { ...deleted } : { ...order }),
      order: deleted,
      isProcessing: false,
      toast: {type: 'SUCCESS', message: toastMessageByAction[actionType]}
    };
  case 'OTR_ASSIGN_DRIVER':
  case 'OTR_UNASSIGN_DRIVER':
  case 'OTR_CHANGE_DRIVER':
  case 'OTR_CHANGE_DRIVER_RATE':
  case 'OTR_SAVE_LEG_CHARGE':
  case 'OTR_UPDATE_LEG_CHARGE':
  case 'OTR_DELETE_LEG_CHARGE':
    // eslint-disable-next-line no-case-declarations    
    const data = {...state.order, legs: state.order.legs.map(leg => leg.id === action.payload.id ? Object.assign({}, action.payload) : {...leg})};
    return {
      ...state,
      orders: state.orders.map(order => order.id === data.id ? { ...data } : { ...order }),
      // update search orders only if we are on search table.
      searched: state.searched.map(order => order.id === data.id ? { ...data } : { ...order }),
      order: data,
      isProcessing: false,
      toast: {type: 'SUCCESS', message: toastMessageByAction[actionType]}
    };

  case 'OTR_ORDER_ERROR':
    return {
      ...state,
      isProcessing: false,
      toast: { type: 'ERROR', message: action.payload},
    };
  default:
    return state;
  }
};

